import type { SupportedLocale } from './i18n';

interface NativeLocaleBridge {
  callHandler(name: string, message: unknown): Promise<unknown>;
}

// Older shells may reject this optional message. Web localization must still work.
export async function synchronizeNativeLocale(
  locale: SupportedLocale,
  bridge: NativeLocaleBridge | undefined,
): Promise<void> {
  try {
    await bridge?.callHandler('tovPlusNativeBridge', {
      type: 'locale_change',
      payload: { locale },
    });
  } catch {
    // The catalog and web direction remain available without a native bridge.
  }
}
